// Date 2023-06-26 13:00:19

import sithMesAgreementEdit from "@/views/sithMes/agreement/SithMesAgreementEdit.vue";
import sithMesAgreementList from "@/views/sithMes/agreement/SithMesAgreementList.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
    {
        path: "/sithMes/agreement/sithMesAgreementEdit",
        name: "sithMesAgreementEdit",
        component: sithMesAgreementEdit,
        props: (route) => ({prop_inline: route.query.inline}),
            meta: metaObject
            },
            {
            path: "/sithMes/agreement/sithMesAgreementList",
            name: "sithMesAgreementList",
            component: sithMesAgreementList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            }
]
